"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushEvents = flushEvents;
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const resolveConfig_1 = require("../utils/resolveConfig");
const utils_2 = require("../../../utils");
const getEventBuffer_1 = require("../utils/getEventBuffer");
const logger = new core_1.ConsoleLogger('Kinesis');
function flushEvents(...args) {
    const [ctx] = (0, utils_1.resolveCtxArgs)(args);
    const { region, flushSize, flushInterval, bufferSize, resendLimit } = (0, resolveConfig_1.resolveConfig)(ctx);
    (0, utils_2.resolveCredentials)(ctx)
        .then(({ credentials, identityId }) => (0, getEventBuffer_1.getEventBuffer)({
        region,
        flushSize,
        flushInterval,
        bufferSize,
        credentials,
        identityId,
        resendLimit,
        userAgentValue: (0, utils_2.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.Record),
    }))
        .then(eventBuffer => eventBuffer.flushAll())
        .catch(e => {
        logger.warn('Failed to flush events.', e);
    });
}
